import React from "react";
import PropTypes from 'prop-types';
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

const createSuccessRow = (data) => {
  const rows = [];
  for (let i = 0; i < data.length; i++) {
    const row = {
      errormessage  : data[i].errormessage || "Something went wrong !!",
      eoid          : data[i].EOID,
      cardName      : data[i].CardName,
      cardEmail     : data[i].CardEmail,
      cardMobile    : data[i].CardMobile,
      recipientName : data[i].RecipientName,
      recipientEmail: data[i].RecipientEmail,
      productionId  : data[i].ProductID,
      promotion     : data[i].Promotion,
      amount        : data[i].Amount,
    };

    rows.push(row);
  }
  return rows;
};

const FailedCardPreview = ({ data }) => {
  const classes = useStyles();
  const rows    = createSuccessRow(data);

  return (
    <>
      <h3> Failed cards </h3>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Error Message</TableCell>
              <TableCell align="right">EOID</TableCell>
              <TableCell align="right">Card Name</TableCell>
              <TableCell align="right">Card Email</TableCell>
              <TableCell align="right">Card Mobile</TableCell>
              <TableCell align="right">Recipient Name</TableCell>
              <TableCell align="right">Recipient Email</TableCell>
              <TableCell align="right">Product</TableCell>
              <TableCell align="right">Campaign</TableCell>
              <TableCell align="right">Amount</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, i) => (
              <TableRow key={i}>
                <TableCell component="th" scope="row">
                  {row.errormessage}
                </TableCell>
                <TableCell align="right">{row.eoid}</TableCell>
                <TableCell align="right">{row.cardName}</TableCell>
                <TableCell align="right">{row.cardEmail}</TableCell>
                <TableCell align="right">{row.cardMobile}</TableCell>
                <TableCell align="right">{row.recipientName}</TableCell>
                <TableCell align="right">{row.recipientEmail}</TableCell>
                <TableCell align="right">{row.productionId}</TableCell>
                <TableCell align="right">{row.promotion}</TableCell>
                <TableCell align="right">{row.amount}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
);
};

FailedCardPreview.propTypes = {
  data: PropTypes.array
};

export default FailedCardPreview;
